export const DOC_CATEGORIES = [
    { key: 'TEMPLATE_EF', label: 'Template de EF' },
    { key: 'TEMPLATE_ESPECIFICACAO_TECNICA', label: 'Template de Especificação Técnica' },
    { key: 'TEMPLATE_EVIDENCIA_TESTES', label: 'Template de Evidência de Testes' },
    { key: 'TEMPLATE_CUTOVER', label: 'Template de Cutover' },
    { key: 'WORKBOOK_ABAP', label: 'Workbook ABAP' },
    { key: 'WORKBOOK_BTP', label: 'Workbook BTP' },
    { key: 'ARQUITETURA', label: 'Documento de Arquitetura' }
];
